import type { system as systemEn } from "../en/system";

export const system: typeof systemEn = {
  dashboard: {
    welcome: "Vítejte zpět, {{name}}!",
    overview: "Tady je přehled vašeho účtu.",
    stats: {
      newInquiries: "Nové poptávky",
      todayCount: "+{{count}} dnes",
      activeTrips: "Aktivní zájezdy",
      departingThisMonth: "{{count}} odjíždí tento měsíc",
      customers: "Zákazníci",
      newThisMonth: "+{{count}} tento měsíc",
      revenueThisMonth: "Tržby tento měsíc",
      vsLastMonth: "{{change}} % oproti minulému měsíci",
    },
    recentInquiries: "Nejnovější poptávky",
    viewAll: "Zobrazit vše",
    noRecentInquiries: "Žádné nové poptávky",
    upcomingDepartures: "Nadcházející termíny",
    noUpcomingDepartures: "Žádné nadcházející termíny",
    participants: "{{participants}} účastníků",
    reminders: "Připomínky",
    relativeTime: {
      justNow: "právě teď",
      minutes: "{{mins}} min",
      hours: "{{hrs}} hod",
      days_one: "{{count}} den",
      days_few: "{{count}} dny",
      days_other: "{{count}} dní",
    },
  },
  myDay: {
    suggestedBy: "Navrhuje MAKEJ!",
    handToAgent: "Předat MAKEJ! k přípravě návrhu",
    allCaughtUp: "Žádné otevřené úkoly — máte hotovo 🎉",
    overdue: "Po termínu",
    today: "Dnes",
    thisWeek: "Tento týden",
    markDone: "Označit jako hotové",
  },
  analytics: {
    subtitle: "Přehled výkonnosti a klíčové metriky",
    loadFailed: "Analytiku se nepodařilo načíst",
    tryAgain: "Zkuste to prosím znovu",
    noData: "Žádná data",
    mom: "m/m",
    yoy: "r/r",
    periods: {
      month: "Tento měsíc",
      quarter: "Toto čtvrtletí",
      year: "Tento rok",
    },
    tabs: {
      revenue: "Tržby",
      orders: "Objednávky",
      trips: "Zájezdy",
      customers: "Zákazníci",
      guides: "Průvodci",
      marketing: "Marketing",
      traffic: "Návštěvnost",
      ads: "Reklamy a ROI",
    },
    summary: {
      revenue: "Tržby",
      orders: "Objednávky",
      occupancy: "Obsazenost",
      customers: "Zákazníci",
      newCount: "+{{count}} nových",
    },
    revenue: {
      aov: "Průměrná hodnota objednávky",
      perParticipant: "Tržby na účastníka",
      forecast: "Odhad tržeb (potvrzené objednávky)",
      forecastDetail: "Potvrzeno: {{confirmed}} | Záloha: {{deposit}}",
      overTime: "Vývoj tržeb v čase",
      thisYear: "Letos",
      lastYear: "Loni",
      byDestination: "Tržby podle destinace",
      tooltipRevenue: "Tržby",
    },
    ordersChart: {
      title: "Objednávky podle stavu",
      tooltipOrders: "Objednávky",
    },
    funnel: {
      title: "Konverzní trychtýř",
      inquiryToQuoted: "Poptávka → Nabídnuto",
      quotedToConfirmed: "Nabídnuto → Potvrzeno",
      confirmedToPaid: "Potvrzeno → Zaplaceno",
      overallConversion: "Celková konverze",
      cancellationRate: "Míra storna",
    },
    trips: {
      topTrips: "Top 5 zájezdů",
      bookings_one: "{{count}} rezervace",
      bookings_few: "{{count}} rezervace",
      bookings_other: "{{count}} rezervací",
      noTrips: "Žádné zájezdy",
      lowOccupancy: "Nízká obsazenost (<30 %)",
      allGoodOccupancy: "Všechny termíny mají dobrou obsazenost",
      trendingDestinations: "Trendy destinací (meziročně)",
      notEnoughData: "Nedostatek dat pro srovnání",
      avgGroupSize: "Průměrná velikost skupiny",
      participantsPerOrder: "účastníků na objednávku",
    },
    guides: {
      datesByGuide: "Termíny podle průvodce",
      dates_one: "{{count}} termín",
      dates_few: "{{count}} termíny",
      dates_other: "{{count}} termínů",
      unstaffed: "Termíny bez průvodce",
      allStaffed: "Všechny termíny mají přiřazeného průvodce",
      overview: "Přehled průvodců",
      guide: "Průvodce",
      dates: "Termíny",
      rating: "Hodnocení",
      revenue: "Tržby",
    },
    customers: {
      byCountry: "Zákazníci podle země",
      newVsReturning: "Noví vs. vracející se",
      new: "Noví",
      returning: "Vracející se",
      newPct: "Noví {{pct}} %",
      returningPct: "Vracející se {{pct}} %",
      clv: "Průměrná celoživotní hodnota zákazníka (CLV)",
      topCustomers: "Top 10 zákazníků",
      trips: "Zájezdy",
      spent: "Útrata",
      noCustomers: "Žádní zákazníci",
      countries: {
        cz: "Česko",
        sk: "Slovensko",
        de: "Německo",
        at: "Rakousko",
        pl: "Polsko",
        hu: "Maďarsko",
        gb: "Velká Británie",
        us: "USA",
      },
    },
    marketing: {
      newsletterSubscribers: "Odběratelé newsletteru",
      growthThisMonth: "+{{count}} tento měsíc",
      ordersBySource: "Objednávky podle zdroje",
      ordersCount_one: "{{count}} objednávka",
      ordersCount_few: "{{count}} objednávky",
      ordersCount_other: "{{count}} objednávek",
      countLabel: "Počet",
      revenueLabel: "Tržby",
      topUtm: "Top UTM kampaně",
      campaign: "Kampaň",
      orders: "Objednávky",
      conversion: "Konverze",
      noUtm: "V tomto období nejsou žádné UTM kampaně",
      revenueBySource: "Tržby podle zdroje",
      source: "Zdroj",
      avgValue: "Ø hodnota",
      sources: {
        webForm: "Webový formulář",
        referral: "Doporučení",
        admin: "Admin",
        phone: "Telefon",
        email: "E-mail",
        social: "Sociální sítě",
        other: "Jiné",
      },
    },
    traffic: {
      checkSettings: "Zkontrolujte nastavení Google Analytics v proměnných prostředí.",
      pageViews: "Zobrazení stránek",
      sessions: "Návštěvy",
      avgBounceRate: "Prům. míra okamžitého opuštění",
      avgSessionDuration: "Prům. délka návštěvy",
      overTime: "Návštěvnost v čase",
      topDestinations: "Top destinace",
      topTrips: "Top zájezdy",
      trip: "Zájezd",
      views: "Zobrazení",
      bounce: "Opuštění",
      avgDuration: "Prům. délka",
      bounceRate: "Míra okamžitého opuštění",
      detailedStats: "Podrobné statistiky destinací",
    },
    ads: {
      checkSettings: "Zkontrolujte nastavení Google Ads v proměnných prostředí.",
      totalSpend: "Celkové výdaje",
      adRevenue: "Tržby z reklam",
      roas: "ROAS",
      conversions: "Konverze",
      avgCpa: "Prům. CPA",
      recommendations: "Doporučení",
      roasByDestination: "ROAS podle destinace",
      roas5plus: "ROAS 5+",
      roas2to5: "ROAS 2–5",
      roas1to2: "ROAS 1–2",
      roasLoss: "ROAS <1 (ztráta)",
      spendVsRevenue: "Výdaje vs. tržby v čase",
      spend: "Výdaje",
      revenue: "Tržby",
      performanceByDestination: "Výkon podle destinace",
      cost: "Náklady",
      cpa: "CPA",
      profitable: "Ziskové",
      loss: "Ztrátové",
      campaigns: "Kampaně",
      campaign: "Kampaň",
      impressions: "Zobrazení",
      clicks: "Kliknutí",
      ctr: "CTR",
    },
  },
  audit: {
    subtitle:
      "Neměnný záznam každé změny stavu, platby, dokumentu, storna, akce agenta a GDPR výmazu.",
    allEntities: "Všechny entity",
    entityTypes: {
      order: "Objednávka",
      invoice: "Faktura",
      payment: "Platba",
      document: "Dokument",
      serviceBooking: "Služba",
      departure: "Termín",
      complaint: "Reklamace",
      agent: "Agent",
      customer: "Zákazník",
      guide: "Průvodce",
      trip: "Zájezd",
      lead: "Poptávka",
      destination: "Destinace",
      activity: "Aktivita",
      settings: "Nastavení",
    },
    actionFilterPlaceholder: "Filtrovat podle akce (např. payment, gdpr_forget)",
    revertedWithConflicts:
      "Vráceno {{reverted}}, přeskočeno {{skipped}} (mezitím změněno): {{labels}}",
    revertedFields_one: "Vráceno {{count}} pole.",
    revertedFields_few: "Vrácena {{count}} pole.",
    revertedFields_other: "Vráceno {{count}} polí.",
    alreadyReverted: "Tato úprava už byla vrácena.",
    revertFailed: "Vrácení se nezdařilo",
    when: "Kdy",
    entity: "Entita",
    action: "Akce",
    actor: "Autor",
    summary: "Shrnutí",
    noEntries: "Žádné záznamy auditu.",
    reverted: "Vráceno",
    revert: "Vrátit",
  },
  users: {
    title: "Správa uživatelů",
    subtitle: "Spravujte přístupy do administrace",
    newUser: "Nový uživatel",
    searchPlaceholder: "Hledat uživatele…",
    loadError: "Chyba při načítání uživatelů",
    noUsers: "Žádní uživatelé",
    user: "Uživatel",
    role: "Role",
    lastLogin: "Poslední přihlášení",
    never: "Nikdy",
    resetPassword: "Resetovat heslo",
    deactivate: "Deaktivovat",
    activate: "Aktivovat",
    toasts: {
      statusChanged: "Stav uživatele změněn",
      statusChangeFailed: "Nepodařilo se změnit stav uživatele",
      deleted: "Uživatel smazán",
      deleteFailed: "Nepodařilo se smazat uživatele",
      created: "Uživatel vytvořen",
      createFailed: "Nepodařilo se vytvořit uživatele",
      updated: "Uživatel upraven",
      updateFailed: "Nepodařilo se upravit uživatele",
      passwordReset: "Heslo bylo resetováno",
      passwordResetFailed: "Nepodařilo se resetovat heslo",
      fillNameEmail: "Vyplňte prosím jméno a e-mail",
      passwordMin: "Heslo musí mít alespoň 8 znaků",
    },
    deleteTitle: "Smazat uživatele",
    deleteMessage: "Opravdu chcete smazat uživatele {{name}}? Tuto akci nelze vrátit.",
    form: {
      editTitle: "Upravit uživatele",
      createTitle: "Nový uživatel",
      name: "Jméno",
      namePlaceholder: "Jan Novák",
      emailPlaceholder: "jan@firma.cz",
      specialistQueue: "Specializovaná fronta",
      queueHelp:
        "Druhy rezervací služeb, které tento člověk vyřizuje (např. Letenka pro letenkového specialistu). Fronta služeb se mu předfiltruje na tyto druhy. Garanti se místo toho směrují podle destinace (nastavuje se na destinaci).",
      password: "Heslo",
      passwordKeepCurrent: "(nechte prázdné pro zachování stávajícího)",
      passwordPlaceholder: "Min. 8 znaků",
      accountActive: "Účet je aktivní",
    },
    roles: {
      adminLabel: "Administrátor",
      adminDesc: "Plný přístup ke všem funkcím",
      editorLabel: "Editor obsahu",
      editorDesc: "Správa zájezdů, destinací, průvodců, recenzí a médií",
      marketingLabel: "Marketing",
      marketingDesc: "Newsletter, segmenty, automatické kampaně, zákazníci",
      salesLabel: "Obchod",
      salesDesc: "Objednávky, zákazníci, poptávky",
      readonlyLabel: "Jen pro čtení",
      readonlyDesc: "Pouze prohlížení bez možnosti úprav",
    },
    resetModal: {
      title: "Resetovat heslo",
      intro: "Nastavte nové heslo pro uživatele",
      newPassword: "Nové heslo",
      submit: "Resetovat heslo",
    },
  },
  integrations: {
    subtitle: "Propojení externích služeb",
    gdriveTitle: "Zálohy na Google Drive",
    gdriveSubtitle: "Týdenní záloha databáze + měsíční záloha úložiště.",
    oauthMisconfigured:
      "OAuth je špatně nakonfigurován: redirect URI tohoto API originu není registrována v konzoli Google Cloud.",
    oauthError: "Google Drive se nepodařilo připojit. Zkuste to prosím znovu.",
    notConfigured:
      "Google OAuth klient není na serveru nakonfigurován (chybí secrets GDRIVE_CLIENT_ID / GDRIVE_CLIENT_SECRET).",
    connected: "Připojeno",
    connectedAs: "Připojeno jako {{email}}",
    backupFolder: "Složka záloh",
    lastBackup: "Poslední záloha",
    noBackupYet: "Zatím žádná záloha",
    runBackupNow: "Spustit zálohu databáze",
    backupStarted: "Záloha spuštěna — obnovte stránku za minutu, aktualizuje se „Poslední záloha“.",
    backupFailed: "Zálohu se nepodařilo spustit. Zkuste to prosím znovu.",
    disconnectConfirm: "Odpojit Google Drive? Plánované zálohy se zastaví.",
    disconnect: "Odpojit",
    connect: "Připojit Google Drive",
  },
};
